import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'; // Added for dispatch
import logolight from '../../assets/images/logo-light.png';
import logodark from '../../assets/images/logo-dark.png';
import icon from '../../assets/images/users/icon.jpg';
import { Container, Row, Col, Card, CardBody, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { loginUser } from '../../store/actions'; // Assuming this is the correct import path

// Constants for route paths
const ROUTE_LOGIN = '/login';
const ROUTE_OTP_VERIFICATION = '/verifyotp';

const LockScreen = () => {
    document.title = "Lock Screen | Onfon Group Legal - Admin Dashboard";

    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch(); // Added dispatch hook

    // Fetch user data from session storage on component mount
    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem("authUser"));
        if (user) {
            setUserData(user);
        }
    }, []);

    // Handle password input change
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (error) setError('');
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!password.trim()) {
            setError('Please enter your password');
            return;
        }

        setLoading(true);

        try {
            // Retrieve token and validate session
            const token = sessionStorage.getItem("authToken");

            if (!token || !userData) {
                setError('Session expired. Please login again.');
                setTimeout(() => {
                    navigate(ROUTE_LOGIN);
                }, 2000);
                return;
            }

            // Simulate an API call to verify the password
            const email = userData.email; // Extract email from user data
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                // Dispatch successful login action
                dispatch(loginUser(data));

                // Redirect to OTP verification page
                navigate(`${ROUTE_OTP_VERIFICATION}/${encodeURIComponent(email)}`);
            } else {
                console.error("API Error:", data);
                setError(data.message || "Login failed. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setError('An unexpected error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="bg-pattern" style={{ height: "100vh" }}>
                <div className="bg-overlay"></div>
                <div className="account-pages pt-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6} md={8} xl={4}>
                                <Card className='mt-5'>
                                    <CardBody className="p-4">
                                        <div className="">
                                            <div className="text-center">
                                                <Link to="/" className="">
                                                    <img src={logodark} alt="" height="24" className="auth-logo logo-dark mx-auto" />
                                                    <img src={logolight} alt="" height="24" className="auth-logo logo-light mx-auto" />
                                                </Link>
                                            </div>
                                            <h4 className="font-size-18 text-muted mt-2 text-center">Locked Screen</h4>
                                            <p className="mb-5 text-center">Enter your password to unlock the screen!</p>

                                            {error && (
                                                <Alert color="danger" className="text-center mb-4">
                                                    {error}
                                                </Alert>
                                            )}

                                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="user-thumb text-center m-b-30">
                                                            <img
                                                                src={userData?.profilePic || icon}
                                                                className="rounded-circle avatar-lg img-thumbnail mx-auto d-block"
                                                                alt="user thumbnail"
                                                            />
                                                            {userData && (
                                                                <h5 className="mt-3">{userData.name || userData.username || 'User'}</h5>
                                                            )}
                                                        </div>

                                                        <div className="mt-4">
                                                            <label className="form-label" htmlFor="userpassword">Password</label>
                                                            <input
                                                                type="password"
                                                                className="form-control"
                                                                id="userpassword"
                                                                placeholder="Enter password"
                                                                value={password}
                                                                onChange={handlePasswordChange}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="d-grid mt-4">
                                                            <button
                                                                className="btn btn-primary waves-effect waves-light"
                                                                type="submit"
                                                                disabled={loading}
                                                            >
                                                                {loading ? 'Processing...' : 'Unlock'}
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-5 text-center">
                                    <p className="text-white-50">
                                        Not you? Return to <Link to={ROUTE_LOGIN} className="fw-medium text-primary">Sign In</Link>
                                    </p>
                                    <p className="text-white-50">© {new Date().getFullYear()} Onfon Group Legal.</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LockScreen;